export default {"src":"/_next/static/media/kaneka.16df99af.svg","height":123,"width":283,"blurWidth":0,"blurHeight":0};